module.exports = __webpack_public_path__ + "static/media/apparaturen_start.e522f62d.jpg";